import React from 'react';

export default class Page5 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToMakeReasonedJudgements');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p><span className="subtitle-table">Step Five</span></p>
                                            <p>Evaluate each option against the criteria. If it meets the
                                                criterion put a 4. If it does not, put an 8.
                                                Choose your preferred option, based on the number of 4s
                                                against your criteria. Remember, you
                                                have placed more importance on some criteria than
                                                others.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>

                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list uiheading sept">
                                                    <li><p>Consider instances where you have procrastinated
                                                        in making a decision. Identify the
                                                        factors that made it difficult for you to make a
                                                        timely and clear choice, and consider what
                                                        steps you should have taken to reduce your anxiety
                                                        or reluctance to decide. </p></li>
                                                    <li><p>Try using the techniques identified in the tool
                                                        next time you need to make a
                                                        reasoned judgement.</p></li>
                                                    <li><p>Think about good judgements you have made. What
                                                        made it go well? Use this
                                                        information to utilise your strengths next time you
                                                        make a reasoned judgement. </p></li>
                                                    <li><p>Ask others you have worked with recently for
                                                        feedback to gauge their perceptions
                                                        on your judgement making process.</p></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>Further Information
                                            </div>
                                            <p>If you found this tool useful then you are likely to find the
                                                following tools both insightful and relevant: </p>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToMakeTimelyDecisions')}>How
                                                        to make timely decisions </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToFocusOnTheBiggerPicture')}>How
                                                        to focus on the bigger picture </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToMakeEthicalDecisions')}>How
                                                        to make ethical decisions </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToBalanceRiskWithPotentialBenefits')}>How
                                                        to balance risk with potential benefits </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToKnowWhenAndHowToTakeRisks')}>How
                                                        to know when and how to take risks. </div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Livio, M.
                                                    (2002).<span className="subtiltereg"> The Golden Ratio: The Story of Phi, The World’s Most Astonishing Number.</span> New
                                                    York:Broadway Books.</p></li>
                                                <li><p className="further_info_content"> Zebrowitz, L.
                                                    (1997).<span className="subtiltereg"> Reading Faces: Window to the Soul?</span> Boulder,
                                                    CO, USA: Westviewpress.</p></li>
                                                <li><p className="further_info_content"> Darby,
                                                    B. &amp; Jeffers, D. (1988.) The Effects of Defendant
                                                    and Juror Attractiveness on Simulated Courtroom
                                                    Trial Decisions.<span className="subtiltereg"> Social Behaviour and Personality,</span> 16(1),
                                                    p39-50.</p></li>
                                                <li><p className="further_info_content"> Asch, S. (1946).
                                                    Forming impressions of personality.<span
                                                        className="subtiltereg"> Journal of Abnormal and Social Psychology,</span> 41,
                                                    258-290.</p></li>
                                                <li><p className="further_info_content"> Aronson, E. (1999).<span
                                                    className="subtiltereg"> The Social Animal.</span> New
                                                    York: Worth Publishers, Inc.</p></li>
                                                <li><p className="further_info_content"> Scholtes, P.,
                                                    Joiner, B. &amp; Streibel, B. (2003).<span
                                                        className="subtiltereg"> The Team Handbook (3rd edition).</span> OrielPAGE.
                                                </p></li>
                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}